import React, { Component, Fragment } from 'react';
import TextField from '../../artzu-ui/src/TextField';
import SelectFieldRelative from '../../artzu-ui/src/SelectFieldRelative';
import Option from '../../artzu-ui/src/Option';
import RequirementsModal from './RequirementsModal';
import { Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

import torontoSkyline from '../../images/toronto_skyline.svg';
// import vancouverSkyline from '../../images/vancouver_skyline.png';
import newyorkSkyline from '../../images/newyork_skyline.png';
import { Helmet } from 'react-helmet';

import Header from './Header';
import Footer from './Footer';
import _ from 'lodash';
import './signup.css';

import { editDashes } from '../NewContact/NewContactForm';

class SignUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirmation: '',
      email: '',
      mobile: '',
      operatingCity: '',
      referralSource: Cookies.get('refCode') ? 'referrerCode' : '',
      referrerCode: Cookies.get('refCode') || '',
      errors: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        password: '',
        passwordConfirmation: '',
        operatingCity: '',
        referralSource: '',
        referrerCode: ''
      }
    };
  }

  getModalDetails() {
    const modalDetails = {
      toronto: {
        image: torontoSkyline,
        fullName: 'the Greater Toronto Area',
        requirements: [
          '21+ years old.',
          "Ontario G driver's license.",
          'Proof of work eligibilty in Canada.'
        ]
      },
      new_york: {
        image: newyorkSkyline,
        fullName: 'New York',
        requirements: ['21+ years old.', 'TLC license holder/eligible.']
      }
      // vancouver: {
      //   image: vancouverSkyline,
      //   fullName: 'Greater Toronto Area',
      //   requirements: ['21+ years old.', "Ontario G driver's license.", 'Proof of work eligibilty in Canada.'],
      // },
    };

    return modalDetails[this.state.operatingCity];
  }

  updateErrors = errors => {
    const newErrors = this.state.errors;

    errors.forEach(({ path, message }) => {
      const type = path.charAt(0).toUpperCase() + path.slice(1);
      newErrors[path] = `${type} ${message}`;
    });
    this.setState({ errors: newErrors });
  };

  updateValue(key, value) {
    key === 'mobile'
      ? value.length > 15
        ? null
        : this.setState({ mobile: value.substring(3) })
      : this.setState({ [key]: value });
    if (key === 'operatingCity' && value) {
      this.setState({ modal: true });
    }
    if (key === 'firstName' || (key === 'lastName' && value)) {
      this.setState({ [key]: value.trim() });
    }
  }

  loggedIn = () =>
    localStorage.state && JSON.parse(localStorage.state).auth.email;

  closeModal = () => {
    this.setState({ modal: false });
  };

  validateEmail = email => {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(String(email).toLowerCase());
  };

  validate = () => {
    const {
      password,
      passwordConfirmation,
      email,
      referralSource,
      mobile
    } = this.state;

    const requiredKeys = [
      'firstName',
      'lastName',
      'email',
      'mobile',
      'password',
      'passwordConfirmation',
      'operatingCity',
      'referralSource',
      referralSource === 'referrerCode' ? 'referrerCode' : ''
    ];
    const inputValues = _.pick(this.state, requiredKeys);
    let status = true;
    const errors = {
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirmation: '',
      email: '',
      mobile: '',
      operatingCity: '',
      referralSource: '',
      referrerCode: ''
    };

    if (
      passwordConfirmation !== password &&
      password &&
      passwordConfirmation
    ) {
      status = false;
      const passwordError = 'These fields must match.';
      errors.passwordConfirmation = passwordError;
      errors.password = passwordError;
    }

    if (password.length < 8) {
      status = false;
      const passwordError = 'Your password must be atleast 8 characters.';
      errors.password = passwordError;
    }

    if (!this.validateEmail(email)) {
      const emailError = 'Your email is invalid.';
      status = false;
      errors.email = emailError;
    }

    Object.keys(_.pickBy(inputValues, _.isEmpty)).forEach(element => {
      status = false;
      errors[element] = 'This is a required field.';
    });

    if (!mobile.match(/^[0-9]{3}-[0-9]{3}-[0-9]{4}$/)) {
      status = false;
      errors.mobile = errors.mobile
        ? 'This is a required field.'
        : 'Invalid phone number';
    }

    this.setState({ errors });
    return status;
  };

  getOptions = () => {
    switch (this.state.operatingCity) {
      case 'toronto':
        return this.torontoOptionsList.map(option => (
          <Option label={option.label} value={option.value} />
        ));
      case 'new_york':
        return this.nyOptionsList.map(option => (
          <Option label={option.label} value={option.value} />
        ));
      default:
        return [null];
    }
  };

  nyOptionsList = [
    { label: 'Online job post', value: 'online-job-post' },
    { label: 'Online search', value: 'online-search' },
    { label: 'Referred by Via', value: 'via-referral' },
    { label: 'Referred by Autzu driver', value: 'referrerCode' },
    { label: 'Billboard or poster', value: 'promotional-material' },
    { label: 'Other', value: 'other' }
  ];

  torontoOptionsList = [
    { label: 'Online job post', value: 'online-job-post' },
    { label: 'Online search', value: 'online-search' },
    { label: 'Seen Autzu cars on the road', value: 'seen-cars' },
    { label: 'Referred by Autzu driver', value: 'referrerCode' },
    { label: 'Uber Greenlight Hub', value: 'greenlight-hub' },
    { label: 'Billboard or poster', value: 'promotional-material' },
    { label: 'Other', value: 'other' }
  ];

  signUp = () => {
    const {
      firstName,
      lastName,
      referralSource,
      password,
      email,
      mobile,
      operatingCity,
      errors,
      referrerCode
    } = this.state;

    const newUserParams = {
      firstName,
      lastName,
      referralSource,
      password,
      email,
      mobile,
      operatingCity,
      referrerCode
    };

    return (
      <div className="signup__container container">
        <Helmet>
          <title>Sign Up | Autzu</title>
          <meta
            name="description"
            content="Sign up to drive with Autzu."
          />
        </Helmet>
        <Header title="Sign Up" />
        <Footer
          params={newUserParams}
          validate={this.validate}
          updateErrors={this.updateErrors}
          tryLogin={this.props.tryLogin}
        />
        <RequirementsModal
          open={this.state.modal}
          details={this.getModalDetails()}
          closeModal={this.closeModal}
        />
        <ScrollLock>
          <EncourageScroll className="signup__content">
            <div className="signup__content--container">
              <div className="signup__text-inputs--container">
                <div className="signup__name-input">
                  <div className="signup__content--margin-right">
                    <TextField
                      error={errors.firstName}
                      heading="First Name"
                      width="100%"
                      onChange={evt =>
                        this.updateValue('firstName', evt.target.value)
                      }
                    />
                  </div>
                  <div className="signup__content--margin-left">
                    <TextField
                      error={errors.lastName}
                      width="100%"
                      heading="Last Name"
                      onChange={evt =>
                        this.updateValue('lastName', evt.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="signup__name-input">
                  <TextField
                    error={errors.email}
                    width="100%"
                    heading="Email"
                    value={this.state.email}
                    onChange={evt =>
                      this.updateValue(
                        'email',
                        evt.target.value.trim().replace(/\s/g, '')
                      )
                    }
                  />
                </div>
                <div className="signup__name-input">
                  <TextField
                    error={errors.password}
                    width="100%"
                    heading="Password"
                    password
                    onChange={evt =>
                      this.updateValue('password', evt.target.value)
                    }
                  />
                </div>
                <div className="signup__name-input">
                  <TextField
                    error={errors.passwordConfirmation}
                    width="100%"
                    heading="Password Confirmation"
                    password
                    onChange={evt =>
                      this.updateValue(
                        'passwordConfirmation',
                        evt.target.value
                      )
                    }
                  />
                </div>
                <div className="signup__name-input">
                  <TextField
                    error={errors.mobile}
                    width="100%"
                    heading="Phone Number"
                    onChange={evt =>
                      this.updateValue('mobile', evt.target.value)
                    }
                    value={`+1 ${editDashes(mobile)}`}
                  />
                </div>
              </div>
              <div className="signup__dropdown-inputs--container">
                <div className="signup__name-input">
                  <SelectFieldRelative
                    error={errors.operatingCity}
                    width="100%"
                    onChange={(val, heading) => {
                      // this.setState({ referralSource: '' });
                      this.updateValue('operatingCity', val);
                    }}
                    title="City">
                    <Option label="Toronto" value="toronto" />
                    <Option label="New York" value="new_york" />
                    {/* <Option label="Vancouver" value="vancouver" /> */}
                  </SelectFieldRelative>
                </div>
                <div className="signup__name-input">
                  <SelectFieldRelative
                    error={errors.referralSource}
                    width="100%"
                    prompt={
                      referralSource && referrerCode
                        ? 'Referred by Autzu driver'
                        : 'Select'
                    }
                    onChange={(val, heading) =>
                      this.updateValue('referralSource', val)
                    }
                    title="How did you hear about us?">
                    {this.getOptions()}
                  </SelectFieldRelative>
                </div>

                {referralSource === 'referrerCode' ? (
                  <div className="signup__name-input">
                    <TextField
                      error={errors.referrerCode}
                      width="100%"
                      value={referrerCode}
                      heading="Autzu Referral Code"
                      onChange={evt =>
                        this.updateValue('referrerCode', evt.target.value)
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
      </div>
    );
  };

  render() {
    if (this.loggedIn()) {
      return <Redirect to="/apply" />;
    }
    return this.signUp();
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp/index.js